// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  border-collapse: collapse;
}

td {
  width: 50px;
  border: 1px solid black;
  padding: 5px;
  text-align: center;
}
/* Gernal Setting */
.text-label {
  font-weight: bolder;
  font-size: 20px;
  display: flex;
  margin: 10px;
  justify-content: cetner;
  align-items: center;
}
.center-box {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Selection  Area Of Image or Filter */

.p-select-section {
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
  display: flex;

  align-items: center;
}

.convol-simulation-title {
  background-color: #ffb800;
  border-radius: 5px;
  padding: 2px;
  margin: 5px;
  text-shadow: 3px 3px 3px rgba(226, 223, 223, 0.747);
  box-shadow: 4px 4px 10px #00000042;
  font-size: 20px;
  display: flex;
  justify-content: center;
  font-weight: bolder;
}

.vis-simulation-title {
  min-width: 300px;
  background-color: #070707;
  border-radius: 5px;
  color: white;
  padding: 2px;
  margin: 5px;
  /* text-shadow: 3px 3px 3px rgba(226, 223, 223, 0.747); */
  /* box-shadow: 4px 4px 10px #00000042; */
  font-size: 20px;
  display: flex;
  justify-content: center;
  font-weight: bolder;
}

.select-section-label {
  width: 80px;
  height: 40px;
  display: flex;
  justify-content: center;
  font-size: x-large;
  font-weight: bolder;
  background-color: white;
  line-height: 40px;
  border-radius: 10px;
  margin: 0 10px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);
}

.select-section-container {
  width: 50%;
  min-width: 800px;
  height: -moz-fit-content;
  height: fit-content;
  /* display: flex; */
  padding: 5px;
  /* border-bottom: 1px solid black */
}

.select-section-items {
  width: 70px;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.selecte-section-img {
  width: 50px;
  height: 50px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);
}

.selecte-section-img:hover {
  transition: scale 0.5s;
  scale: 1.2;
}

/* Overview Area*/

.main-practice-section {
  width: calc(100%-4rem);
  min-width: -moz-fit-content;
  min-width: fit-content;
  background-color: rgba(128, 128, 128, 0.1);
  padding: 2rem;
  margin: 10px 2rem;
  display: flex;
}

/* Selected Image Section*/
.p-convol-overview {
  background-color: white;
  box-shadow: 2px 2px 10px #00000042;
  display: flex;
  justify-content: center;
}

/* Overview Area of Section */
.selected-image-section {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
}

.selected-filter-section {
  min-height: -moz-fit-content;
  min-height: fit-content;
  padding: 0.25rem;
  display: flex;
  font-size: 20px;
  font-weight: bolder;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* margin: 3px; */
}

/* .covoled-img-container{
  width: 310px;
  height: 310px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
} */

.selected-result-section {
  width: 310px;
  height: 286px;
  padding: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Overview Area of Container */

.selected-image-container {
  width: 280px;
  height: 280px;
  position: relative;
}

.selected-filter-container {
  width: 120px;
  height: -moz-fit-content;
  height: fit-content;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  /* border: 1px solid black; */
}

.selected-result-container {
  position: relative;
}

/* Overview Area of Image(Img, Filter and Convol-Result) */

.ov-selected-image {
  width: 280px;
  height: 280px;
  image-rendering: pixelated;
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);
}

.ov-selected-filter {
  width: 120px;
  height: 120px;
  margin: 0.25rem;
  image-rendering: pixelated;
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);
}
.ov-selected-result {
  width: 273px;
  height: 273px;
  image-rendering: pixelated;
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);
}

/* Overview Area of Selected Convol-Area */

.filter-hovered-area {
  width: 10.5px;
  height: 10.5px;
  position: absolute;
  left: 0px;
  top: 0px;
  border: 1px solid red;
  pointer-events: none;
  box-sizing: border-box;
}

.filter-clicked-area {
  width: 10.5px;
  height: 10.5px;
  position: absolute;
  left: 0px;
  top: 0px;
  border: 1px solid blue;
  pointer-events: none;
  box-sizing: border-box;
}

.result-filter-hovered-area {
  width: 3.5px;
  height: 3.5px;
  position: absolute;
  left: 0px;
  top: 0px;
  border: 1px solid red;
  pointer-events: none;
  box-sizing: border-box;
}

.result-filter-clicked-area {
  width: 3.5px;
  height: 3.5px;
  position: absolute;
  left: 0px;
  top: 0px;
  border: 1px solid blue;
  pointer-events: none;
  box-sizing: border-box;
}

.convol-reuslt-container {
  width: 200px;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sobel-temp-container {
  width: 312;
  height: -moz-fit-content;
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 10px;
}

.convol-result-image {
  width: 120px;
  height: 120px;
  border: 1px solid black;
}

/* Practice Convolution Section */
.p-convol-section {
  width: 100%;
  padding: 2rem;
  background-color: white;
  box-shadow: 2px 2px 10px #00000042;
  margin-left: 2rem;

  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
}

/* Left Section */

.selected-image {
  width: 160px;
  height: 160px;
}

.median-text {
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;

  font-weight: bolder;
  margin: 10px;
}

.p-graphic-left-setion {
  min-width: -moz-fit-content;
  min-width: fit-content;
  display: flex;
  margin: 10px;
  /* padding: 2rem; */
  justify-content: center;
  /* align-items: center; */
}

.graphic-container {
  min-width: -moz-fit-content;
  min-width: fit-content;
}

.left-graphic-filter-container {
  display: flex;
  flex-direction: column;
}

.p-graphic-filter,
.p-graphic-image {
}

.p-graphic-row {
  display: flex;
  justify-content: center;
}

.p-graphic-cell {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  border: 1px solid black;
}

/* Middle Section*/
.p-math-operator {
  display: flex;
  justify-content: center;
  align-items: center;
}
.p-math-mid-setion {
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
}

.p-math-mid-container {
  min-height: 140px;
  padding: 0 0 40px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
}

.p-math-mid-operator-container,
.p-math-mid-filter-container,
.p-math-mid-number-container {
  display: flex;
  justify-content: space-between;
}

.p-math-mid-filter-container div,
.p-math-mid-number-container div {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  /* margin: 5px; */
  border: 1px solid black;
}

.p-math-mid-operator-container div {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px;
  padding: 5px;
}

.p-math-image div {
  display: flex;
}

.canvas-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.mathematical-grid {
  width: 30px;
  height: 30px;
}

.mathematical-grid:hover::before {
  position: absolute;
  width: 380px;
  font-size: 20px;
  content: "在卷積運算中，濾波器的值將會與選取區域的相對應值進行相乘，然後將所有這些乘積相加以得到結果。這個過程用於提取該區域的特徵。";
  background-color: white;
  box-shadow: 0 0 3px;
  transform: translate(-50%, -100%); /* 向左移动50%，向上移动100% */
}

/* Right Section */

.p-ans-right-setion {
  display: flex;
  flex-direction: column;
  justify-content: flex;
  align-items: center;
}

.ans-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
}

.ans-grid {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid black;
}

/* Convolution Practice Section */

.convol-input {
  width: 80px;
  height: 80px;
  display: flex;

  justify-content: center;
  align-items: center;
  border: 1px solid black;
  padding: 5px;
}

/* Easy Convolution Practice */

.easy-conv-selection {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #0707070c;
}

.selected-img,
.selected-filter,
.s-c-container {
  border: 1px solid black;
}

.easy-conv-img-container:hover,
.easy-conv-filter-container:hover{
  transition: scale 0.5s;
  scale: 1.2;
  border: 1px solid red;
}

.selected-result {
  border: 1px solid black;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
}

.ec-label {
  min-width: 90px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bolder;
  margin: 5px;
}
.easy-conv-img-pixel,
.easy-conv-filter-pixel,
.selected-result-pixel {
  width: 50px;
  height: 50px;
  border: 1px solid black;
  text-align: center;
  line-height: 50px;
}


.s-img,
.s-c-img{
  width: 200px;
  height: 200px;
}

.s-c-label{
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 120px;
  font-size: 20px;
  font-weight: bolder;
  margin: 5px;
}

.target-img{
  border: 3px solid red;
}`, "",{"version":3,"sources":["webpack://./src/pages/ch4/ConvolutionPractice.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;AACA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,uCAAuC;;AAEvC;EACE,WAAW;EACX,wBAAmB;EAAnB,mBAAmB;EACnB,aAAa;;EAEb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,mDAAmD;EACnD,kCAAkC;EAClC,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,yDAAyD;EACzD,wCAAwC;EACxC,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,wBAAmB;EAAnB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA,iBAAiB;;AAEjB;EACE,sBAAsB;EACtB,2BAAsB;EAAtB,sBAAsB;EACtB,0CAA0C;EAC1C,aAAa;EACb,iBAAiB;EACjB,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,uBAAuB;EACvB,kCAAkC;EAClC,aAAa;EACb,uBAAuB;AACzB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,4BAAuB;EAAvB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;;;;;GAOG;;AAEH;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,+BAA+B;;AAE/B;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,wBAAmB;EAAnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;;EAEnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,0DAA0D;;AAE1D;EACE,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,0BAA0B;EAC1B,6CAA6C;AAC/C;AACA;EACE,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA,0CAA0C;;AAE1C;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,wBAAmB;EAAnB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,kCAAkC;EAClC,iBAAiB;;EAEjB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,iBAAiB;;AAEjB;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;;EAEf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,2BAAsB;EAAtB,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,2BAAsB;EAAtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;AAEA;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,wEAAwE;EACxE,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC,EAAE,qBAAqB;AAC1D;;AAEA,kBAAkB;;AAElB;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,iCAAiC;;AAEjC;EACE,WAAW;EACX,YAAY;EACZ,aAAa;;EAEb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA,8BAA8B;;AAE9B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;;EAEE,sBAAsB;EACtB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;AACA;;;EAGE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;;AAGA;;EAEE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["table {\n  border-collapse: collapse;\n}\n\ntd {\n  width: 50px;\n  border: 1px solid black;\n  padding: 5px;\n  text-align: center;\n}\n/* Gernal Setting */\n.text-label {\n  font-weight: bolder;\n  font-size: 20px;\n  display: flex;\n  margin: 10px;\n  justify-content: cetner;\n  align-items: center;\n}\n.center-box {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Selection  Area Of Image or Filter */\n\n.p-select-section {\n  width: 100%;\n  height: fit-content;\n  display: flex;\n\n  align-items: center;\n}\n\n.convol-simulation-title {\n  background-color: #ffb800;\n  border-radius: 5px;\n  padding: 2px;\n  margin: 5px;\n  text-shadow: 3px 3px 3px rgba(226, 223, 223, 0.747);\n  box-shadow: 4px 4px 10px #00000042;\n  font-size: 20px;\n  display: flex;\n  justify-content: center;\n  font-weight: bolder;\n}\n\n.vis-simulation-title {\n  min-width: 300px;\n  background-color: #070707;\n  border-radius: 5px;\n  color: white;\n  padding: 2px;\n  margin: 5px;\n  /* text-shadow: 3px 3px 3px rgba(226, 223, 223, 0.747); */\n  /* box-shadow: 4px 4px 10px #00000042; */\n  font-size: 20px;\n  display: flex;\n  justify-content: center;\n  font-weight: bolder;\n}\n\n.select-section-label {\n  width: 80px;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  font-size: x-large;\n  font-weight: bolder;\n  background-color: white;\n  line-height: 40px;\n  border-radius: 10px;\n  margin: 0 10px;\n  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);\n}\n\n.select-section-container {\n  width: 50%;\n  min-width: 800px;\n  height: fit-content;\n  /* display: flex; */\n  padding: 5px;\n  /* border-bottom: 1px solid black */\n}\n\n.select-section-items {\n  width: 70px;\n  height: 70px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.selecte-section-img {\n  width: 50px;\n  height: 50px;\n  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);\n}\n\n.selecte-section-img:hover {\n  transition: scale 0.5s;\n  scale: 1.2;\n}\n\n/* Overview Area*/\n\n.main-practice-section {\n  width: calc(100%-4rem);\n  min-width: fit-content;\n  background-color: rgba(128, 128, 128, 0.1);\n  padding: 2rem;\n  margin: 10px 2rem;\n  display: flex;\n}\n\n/* Selected Image Section*/\n.p-convol-overview {\n  background-color: white;\n  box-shadow: 2px 2px 10px #00000042;\n  display: flex;\n  justify-content: center;\n}\n\n/* Overview Area of Section */\n.selected-image-section {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5px;\n}\n\n.selected-filter-section {\n  min-height: fit-content;\n  padding: 0.25rem;\n  display: flex;\n  font-size: 20px;\n  font-weight: bolder;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  /* margin: 3px; */\n}\n\n/* .covoled-img-container{\n  width: 310px;\n  height: 310px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n} */\n\n.selected-result-section {\n  width: 310px;\n  height: 286px;\n  padding: 2px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Overview Area of Container */\n\n.selected-image-container {\n  width: 280px;\n  height: 280px;\n  position: relative;\n}\n\n.selected-filter-container {\n  width: 120px;\n  height: fit-content;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  /* border: 1px solid black; */\n}\n\n.selected-result-container {\n  position: relative;\n}\n\n/* Overview Area of Image(Img, Filter and Convol-Result) */\n\n.ov-selected-image {\n  width: 280px;\n  height: 280px;\n  image-rendering: pixelated;\n  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);\n}\n\n.ov-selected-filter {\n  width: 120px;\n  height: 120px;\n  margin: 0.25rem;\n  image-rendering: pixelated;\n  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);\n}\n.ov-selected-result {\n  width: 273px;\n  height: 273px;\n  image-rendering: pixelated;\n  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);\n}\n\n/* Overview Area of Selected Convol-Area */\n\n.filter-hovered-area {\n  width: 10.5px;\n  height: 10.5px;\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  border: 1px solid red;\n  pointer-events: none;\n  box-sizing: border-box;\n}\n\n.filter-clicked-area {\n  width: 10.5px;\n  height: 10.5px;\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  border: 1px solid blue;\n  pointer-events: none;\n  box-sizing: border-box;\n}\n\n.result-filter-hovered-area {\n  width: 3.5px;\n  height: 3.5px;\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  border: 1px solid red;\n  pointer-events: none;\n  box-sizing: border-box;\n}\n\n.result-filter-clicked-area {\n  width: 3.5px;\n  height: 3.5px;\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  border: 1px solid blue;\n  pointer-events: none;\n  box-sizing: border-box;\n}\n\n.convol-reuslt-container {\n  width: 200px;\n  height: 300px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.sobel-temp-container {\n  width: 312;\n  height: fit-content;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-right: 10px;\n}\n\n.convol-result-image {\n  width: 120px;\n  height: 120px;\n  border: 1px solid black;\n}\n\n/* Practice Convolution Section */\n.p-convol-section {\n  width: 100%;\n  padding: 2rem;\n  background-color: white;\n  box-shadow: 2px 2px 10px #00000042;\n  margin-left: 2rem;\n\n  display: flex;\n  flex-direction: column;\n  /* justify-content: center; */\n  align-items: center;\n}\n\n/* Left Section */\n\n.selected-image {\n  width: 160px;\n  height: 160px;\n}\n\n.median-text {\n  height: 80px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n\n  font-weight: bolder;\n  margin: 10px;\n}\n\n.p-graphic-left-setion {\n  min-width: fit-content;\n  display: flex;\n  margin: 10px;\n  /* padding: 2rem; */\n  justify-content: center;\n  /* align-items: center; */\n}\n\n.graphic-container {\n  min-width: fit-content;\n}\n\n.left-graphic-filter-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.p-graphic-filter,\n.p-graphic-image {\n}\n\n.p-graphic-row {\n  display: flex;\n  justify-content: center;\n}\n\n.p-graphic-cell {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5px;\n  border: 1px solid black;\n}\n\n/* Middle Section*/\n.p-math-operator {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.p-math-mid-setion {\n  display: flex;\n  flex-direction: column;\n  /* justify-content: center; */\n  align-items: center;\n}\n\n.p-math-mid-container {\n  min-height: 140px;\n  padding: 0 0 40px 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  /* align-items: center; */\n}\n\n.p-math-mid-operator-container,\n.p-math-mid-filter-container,\n.p-math-mid-number-container {\n  display: flex;\n  justify-content: space-between;\n}\n\n.p-math-mid-filter-container div,\n.p-math-mid-number-container div {\n  width: 30px;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5px;\n  /* margin: 5px; */\n  border: 1px solid black;\n}\n\n.p-math-mid-operator-container div {\n  width: 30px;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 5px;\n  padding: 5px;\n}\n\n.p-math-image div {\n  display: flex;\n}\n\n.canvas-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n}\n\n.mathematical-grid {\n  width: 30px;\n  height: 30px;\n}\n\n.mathematical-grid:hover::before {\n  position: absolute;\n  width: 380px;\n  font-size: 20px;\n  content: \"在卷積運算中，濾波器的值將會與選取區域的相對應值進行相乘，然後將所有這些乘積相加以得到結果。這個過程用於提取該區域的特徵。\";\n  background-color: white;\n  box-shadow: 0 0 3px;\n  transform: translate(-50%, -100%); /* 向左移动50%，向上移动100% */\n}\n\n/* Right Section */\n\n.p-ans-right-setion {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex;\n  align-items: center;\n}\n\n.ans-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100px;\n}\n\n.ans-grid {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid black;\n}\n\n/* Convolution Practice Section */\n\n.convol-input {\n  width: 80px;\n  height: 80px;\n  display: flex;\n\n  justify-content: center;\n  align-items: center;\n  border: 1px solid black;\n  padding: 5px;\n}\n\n/* Easy Convolution Practice */\n\n.easy-conv-selection {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #0707070c;\n}\n\n.selected-img,\n.selected-filter,\n.s-c-container {\n  border: 1px solid black;\n}\n\n.easy-conv-img-container:hover,\n.easy-conv-filter-container:hover{\n  transition: scale 0.5s;\n  scale: 1.2;\n  border: 1px solid red;\n}\n\n.selected-result {\n  border: 1px solid black;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5px;\n}\n\n.ec-label {\n  min-width: 90px;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n  font-weight: bolder;\n  margin: 5px;\n}\n.easy-conv-img-pixel,\n.easy-conv-filter-pixel,\n.selected-result-pixel {\n  width: 50px;\n  height: 50px;\n  border: 1px solid black;\n  text-align: center;\n  line-height: 50px;\n}\n\n\n.s-img,\n.s-c-img{\n  width: 200px;\n  height: 200px;\n}\n\n.s-c-label{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 120px;\n  font-size: 20px;\n  font-weight: bolder;\n  margin: 5px;\n}\n\n.target-img{\n  border: 3px solid red;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
